import { render } from "./ContactBack.vue?vue&type=template&id=74daa3d2"
import script from "./ContactBack.vue?vue&type=script&lang=js"
export * from "./ContactBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__